import React from "react";
import styles from "./searchInput.module.css";
import { FiSearch } from "react-icons/fi";

const SearchInput = (props) => {
  return (
    <div className={styles.search_input} style={props?.containerStyle}>
      <input
      style={props?.style}
        placeholder={props?.placeholder}
        onChange={props?.onChange}
        className={styles.input}
      />
      <FiSearch className={styles.icon} />
    </div>
  );
};

export default SearchInput;
